module.exports = __webpack_public_path__ + "img/L_308_0.860beb6e.png";